module.exports = __webpack_public_path__ + "static/media/package_care_20_hours.941246c0.svg";